import { styled } from '@linaria/react';

import { Typography } from '../Typography/Typography';

export const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 48px;
  background-color: #f9456b;
  z-index: 1000;
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
`;

export const LeftBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const Text = styled(Typography.H4)`
  max-width: calc(100% - 32px);
`;

export const RightBlock = styled.div`
  display: flex;
`;
